export class PinPosition {
    public x: number;
    public y: number;
    public cx: number;
    public cy: number;

    public get right(): number {
        return this.x + this.cx;
    }

    public get bottom(): number {
        return this.y + this.cy;
    }

    public isInside(pos: PinPosition): boolean {
        if (pos.x < this.right && pos.right >= this.x) {
            if (pos.y < this.bottom && pos.bottom >= this.y) {
                return true;
            }
        }
        return false;
    }
}